import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction, LazyImport } from 'owa-bundling';
import './orchestrators/accountStateChangeOrchestrator';
import type { monthlyUpdatesState } from './store/schema/monthlyUpdatesState';
import type { UpsellBizBarState } from './store/schema/upsellBizBarState';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "IrisAsync" */ './lazyIndex'),
    {
        name: 'IrisAsync',
    }
);
export const lazyInitializeBizBarIrisState: LazyAction<
    typeof lazyIndex.initializeUpsellBarState,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeUpsellBarState);
export const lazyInitializeLeftNavUpsellState: LazyAction<
    typeof lazyIndex.initializeLeftNavUpsellState,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeLeftNavUpsellState);
export const lazyBizBarArcStore: LazyImport<
    UpsellBizBarState,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.BizBarArcStore());
export const lazyMonthlyUpdatesStore: LazyImport<
    monthlyUpdatesState,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.MonthlyUpdatesStore());

export const lazyLogImpressionCall: LazyAction<
    typeof lazyIndex.makeImpressionCall,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.makeImpressionCall);
export const lazyLogBeaconCall: LazyAction<typeof lazyIndex.makeBeaconCall, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.makeBeaconCall);

export const lazyShouldShowMonthlyUpdates: LazyAction<
    typeof lazyIndex.shouldShowMonthlyUpdates,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.shouldShowMonthlyUpdates);
export const lazyInitializeCopilotTeachingPopoverState: LazyAction<
    typeof lazyIndex.initializeCopilotTeachingPopoverState,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeCopilotTeachingPopoverState);

export { monthlyUpdatesState } from './store/schema/monthlyUpdatesState';

export const lazyInitializeAddAccountCampaignState: LazyAction<
    typeof lazyIndex.initializeAddAccountCampaignState,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeAddAccountCampaignState);
export { AddAccountCampaignState } from './store/schema/addAccountCampaignState';
export {
    getAddAccountCampaignViewState,
    getAddAccountCampaignDetails,
} from './selectors/addAccountCampaignStoreSelectors';

// OWA Referral Campaign
export const lazyInitializeOwaMonarchReferralCampaignState: LazyAction<
    typeof lazyIndex.initializeOwaMonarchReferralCampaignState,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeOwaMonarchReferralCampaignState);
export {
    getOwaMonarchReferralCampaignViewState,
    getOwaMonarchReferralCampaignDetails,
} from './selectors/owaMonarchReferralCampaignStoreSelectors';
export { getLeftNavStore } from './store/LeftNavStore';
export { copilotTeachingPopoverStore } from './store/CopilotTeachingPopoverStore';
export { CopilotTeachingPopoverAnchorID } from './utils/CopilotTeachingPopoverAnchorID';
